import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1cc9451c&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Main.vue?vue&type=style&index=1&id=1cc9451c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9451c",
  null
  
)

export default component.exports